import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function useModuleGuard(key) {
  const { moduleOn, settingsLoaded } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (settingsLoaded && key && !moduleOn(key)) navigate("/", { replace: true });
  }, [settingsLoaded, key, moduleOn, navigate]);
}
